module.exports = __webpack_public_path__ + "assets/7bcca9f4110f24834f28253833dc0f78.png";